const UnderTabComponents = ({prefix, identifier, setActiveSubCard, activeSubCard}) => {
    return (
        <div className="d-flex gap-2 py-1 mt-1" style={{
            borderTop: "1px solid rgb(188, 241, 248)",
            borderBottom: "1px solid rgb(188, 241, 248)",
        }}
        >
            <button
                onClick={() => setActiveSubCard(`under_approval_${prefix}_${identifier}`)}
                className={`border-0 d-flex align-items-center gap-1 fs-12px text-prime-100 px-2 py-1 rounded-4 ${
                activeSubCard == `under_approval_${prefix}_${identifier}` ? "bg-prime-20" : "bg-white"
                } `}
            >
                {activeSubCard == `under_approval_${prefix}_${identifier}` ? (
                <i className="icon-remove_circle_outline text-prime-100"></i>
                ) : (
                <i className="icon-add_circle_outline text-prime-100"></i>
                )}
                Under approval
            </button>
            <button
                onClick={() => setActiveSubCard(`sanction_${prefix}_${identifier}`)}
                className={`border-0 d-flex align-items-center gap-1 fs-12px text-prime-100 px-2 py-1 rounded-4 ${
                activeSubCard == `sanction_${prefix}_${identifier}` ? "bg-prime-20" : "bg-white"
                } `}
            >
                {activeSubCard == `sanction_${prefix}_${identifier}` ? (
                    <i className="icon-remove_circle_outline text-prime-100"></i>
                ) : (
                    <i className="icon-add_circle_outline text-prime-100"></i>
                )}
                Sanction
            </button>
            <button
                onClick={() => setActiveSubCard(`pending_payments_${prefix}_${identifier}`)}
                className={`border-0 d-flex align-items-center gap-1 fs-12px text-prime-100 px-2 py-1 rounded-4 ${
                activeSubCard == `pending_payments_${prefix}_${identifier}` ? "bg-prime-20" : "bg-white"
                } `}
            >
                {activeSubCard == `pending_payments_${prefix}_${identifier}` ? (
                    <i className="icon-remove_circle_outline text-prime-100"></i>
                ) : (
                    <i className="icon-add_circle_outline text-prime-100"></i>
                )}
                Pending Payments
            </button>
            {
                prefix === 'subhead' &&
                <button
                    onClick={() => setActiveSubCard(`pending_bank_settlements_${prefix}_${identifier}`)}
                    className={`border-0 d-flex align-items-center gap-1 fs-12px text-prime-100 px-2 py-1 rounded-4 ${
                    activeSubCard == `pending_bank_settlements_${prefix}_${identifier}` ? "bg-prime-20" : "bg-white"
                    } `}
                >
                    {activeSubCard == `pending_bank_settlements_${prefix}_${identifier}` ? (
                        <i className="icon-remove_circle_outline text-prime-100"></i>
                    ) : (
                        <i className="icon-add_circle_outline text-prime-100"></i>
                    )}
                    Pending Bank Settlements
                </button>
            }
            
        </div>
    )
}

export default UnderTabComponents;